import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-diceIcons-D8',
    templateUrl: './D8.svg',
    styleUrls: ['./diceIcons-D8.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiceIconsD8Component { }
